<template>
  <div class="content background1" style="padding: 10px">
    <div class="tableBox11">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <!--<div class="searchBox2">
            <div class="searchBox-list">
              <div class="searchBox-black">
                <label class="searchBox-label">{{$t('label_257')}}</label>
                <div class="searchBox-condition">
                  <el-input
                    class="input-class"
                    v-model="searchParam.customerName"
                    :placeholder="$t('input_35')"
                  >
                  </el-input>
                </div>
              </div>
              <div class="searchBox-black">
                <label class="searchBox-label">{{$t('label_260')}}</label>
                <div class="searchBox-condition">
                  <el-date-picker
                    class="date-class"
                    v-model="searchParam.signTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    :placeholder="$t('label_329')"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="searchBox-black">
                <label class="searchBox-label">{{$t('label_264')}}</label>
                <div class="searchBox-condition">
                  <el-date-picker
                    class="date-class"
                    v-model="searchParam.signTime2"
                    value-format="yyyy-MM-dd"
                    type="date"
                    :placeholder="$t('label_388')"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="searchBox-black">
                <label class="searchBox-label">{{$t('label_268')}}</label>
                <div class="searchBox-condition" style="width: 150px">
                  <el-select
                    class="select-class"
                    v-model="searchParam.customerType"
                    :placeholder="$t('input_65')"
                  >
                    <el-option :label="$t('すべて')" :value="''"></el-option>
                    <el-option
                      v-for="(item, index) in customerTypeList"
                      :label="item.name"
                      :value="item.id"
                      :key="index"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="searchBox-black">
                <label class="searchBox-label">{{$t('label_83')}}</label>
                <div class="searchBox-condition" style="width: 150px">
                  <el-select
                    class="select-class"
                    v-model="searchParam.personChargeName"
                    :clearable="true"
                    :filterable="true"
                    :placeholder="$t('input_37')"
                  >
                    <el-option :label="$t('すべて')" :value="''"></el-option>
                    <template v-for="(item, index) in personChargeNameList">
                      <el-option
                        :label="item.fullName"
                        :value="item.fullName"
                        :key="index"
                      >
                      </el-option>
                    </template>
                  </el-select>
                </div>
              </div>
              &lt;!&ndash; <div class="searchBox-black">
                <label class="searchBox-label">维保模式</label>
                <div class="searchBox-condition" style="width: 150px">
                  <el-select
                    class="select-class"
                    v-model="searchParam.maintenanceType"
                    :placeholder="$t('input_65')"
                  >
                    <el-option :label="'すべて'" :value="''"></el-option>
                    <el-option
                      v-for="(item, index) in maintenanceList"
                      :label="item.name"
                      :value="item.id"
                      :key="index"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div> &ndash;&gt;
              <div
                class="searchButton"
                @click="search({ pageNo: 1, pageSize: pageSize })"
              >
                {{$t('btn_2')}}
              </div>
            </div>
            <div class="searchBox-button">
              <label class="searchBox-label">{{$t('label_275')}}</label>
              <div class="searchBox-condition">
                <ul class="searchBox-condition-list">
                  <li
                    :class="{ on: searchParam.status === item.id }"
                    v-for="(item, index) in stateList"
                    @click="searchStatus(item.id)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>-->
          <div class="chooseBox spaceBetween" style="height: 100px;width:calc(100% - 20px);padding-top: 20px">
            <div class="selectBox">
              <div>
                <div class="selectChoose">
                  <div class="selectText">
                    <p>{{$t('label_257')}}</p>
                  </div>
                  <div class="select">
                    <el-input
                      class="input-class"
                      v-model="searchParam.customerName"
                      :placeholder="$t('input_35')"
                    >
                    </el-input>
                  </div>
                </div>
              </div>
              <div>
                <div class="selectChoose" style="width: 460px">
                  <div class="selectText">
                    <p>{{$t('label_260')}}</p>
                  </div>
                  <div class="select" >

                    <el-date-picker
                      class="date-class"
                      v-model="searchParam.signTime"
                      value-format="yyyy-MM-dd"
                      type="date"
                      :placeholder="$t('label_329')"
                    >
                    </el-date-picker>
                  </div>
                  <div class="selectText" style="width: 40px">
                    <p>{{$t('label_264')}}</p>
                  </div>
                  <div class="select">
                    <el-date-picker
                      class="date-class"
                      v-model="searchParam.signTime2"
                      value-format="yyyy-MM-dd"
                      type="date"
                      :placeholder="$t('label_388')"
                    >
                    </el-date-picker>
                  </div>
                </div>
              </div>
              <div>
                <div class="selectChoose">
                  <div class="selectText">
                    <p>{{$t('label_83')}}</p>
                  </div>
                  <div class="select">
                    <el-select
                      class="select-class"
                      v-model="searchParam.personChargeName"
                      :clearable="true"
                      :filterable="true"
                      :placeholder="$t('input_37')"
                    >
                      <el-option :label="$t('label_272')" :value="''"></el-option>
                      <template v-for="(item, index) in personChargeNameList">
                        <el-option
                          :label="item.fullName"
                          :value="item.fullName"
                          :key="index"
                        >
                        </el-option>
                      </template>
                    </el-select>
                  </div>
                </div>
              </div>
              <div>
                <div class="selectChoose" style="width: 950px">
                  <div class="selectText" style="width: 105px">
                    <p>{{$t('label_275')}}</p>
                  </div>
                  <div class="select" style="width: 850px">
                    <div class="spotStatusNumList" style="justify-content: left">
                      <div class="statusMesBox" v-for="(item,index) in spotStatusNumList" :class="item.check==true?'check':''" style="margin-right: 10px;padding: 10px 0 0 0">
                        <div class="iconBox" :style="{'background':item.color}"><i :class="item.icon"></i></div>
                        <div class="textBox">
                          <p>{{$t(item.text)}}</p>
                          <p class="num" :style="{'color':item.color}">{{item.num}}</p>
                        </div>
                        <div class="checkBox">
                          <el-checkbox label="" v-model="item.check"></el-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
              <div class="buttonBox buttonBoxRight" style="width: 150px;top: 10px;right: 10px">
                <div>
                  <div class="chooseButton sendButton" @click="search({ pageNo: 1, pageSize: pageSize })"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
                </div>
              </div>
            </div>
          <div class="list"
            style="z-index: 10; padding-top: 10px;border-top: 1px solid #dcdcdc;width: calc(100% - 20px);height: calc(100% - 280px);position: absolute;top: 180px;left: 10px">

            <div class="buttonBox" style="margin-left: 10px;">
              <div >
                <div
                  class="chooseButton deleteButton"
                  @click="Invalid"
                >
                  <i class="el-icon-circle-close"></i>
                  {{$t('btn_5')}}
                </div>
              </div>
              <div style="margin-left: 4px;">
                <div class="chooseButton searchButton" @click="detailDialog=true"><i class="el-icon-tickets"></i> {{$t('btn_3')}}</div>
              </div>
              <div style="margin-left: 4px;">
                <div
                  class="chooseButton exportButton"
                  @click="renewalDialog=true"
                >
                  {{$t('btn_7')}}
                </div>
              </div>
              <div>
                <div
                  class="chooseButton exportButton"
                  @click="sign"
                >
                  <i class="el-icon-s-check"></i>
                  {{$t('btn_8')}}
                </div>
              </div>
            </div>
            <List
              :tableData="tableData"
              :tableList="tableList"
              :pageSize="pageSize"
              :pageNo="pageNo"
              @parentMethod="getInfo"
            ></List>
          </div>
          <div ref="page" class="page">
            <Page
              ref="pageModel"
              :total="pageCount"
              :display="pageSize"
              :pagegroup="3"
              :currentspage="1"
              @parentMethod="search"
            ></Page>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('btn_8')"
      :center="true"
      :visible.sync="signDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="500px"
      custom-class="dialog-style dialogLoading"
    >
      <div class="dialog-content">
        <el-form ref="form" :model="signParam" label-width="120px">
          <el-form-item :label="$t('label_257')">
            <el-autocomplete
              style="width: 100%"
              v-model="signParam.customerName"
              :fetch-suggestions="queryCustomer"
              @select="selectCustomer"
              :trigger-on-focus="false"
              value-key="customerName"
            >
            </el-autocomplete>
          </el-form-item>
          <el-form-item :label="$t('label_325')">
            <el-input v-model="signParam.address" disabled=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('label_260')">
            <el-date-picker
              v-model="signParam.signTime"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$t('input_89')"
              :clearable="false"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('label_329')">
            <el-date-picker
              v-model="signParam.startDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$t('input_89')"
              :clearable="false"
              :picker-options="pickerOptions0"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('label_333')">
            <el-date-picker
              v-model="signParam.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$t('input_89')"
              :clearable="false"
              :picker-options="pickerOptions1"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('label_336')">
            <el-autocomplete
              style="width: 100%"
              v-model="signParam.signStaffName"
              :placeholder="$t('input_36')"
              :fetch-suggestions="queryStaff1"
              @select="selectStaff1"
              :trigger-on-focus="true"
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <el-form-item :label="$t('label_83')">
            <el-autocomplete
              style="width: 100%"
              v-model="signParam.personChargeName"
              :placeholder="$t('input_37')"
              :fetch-suggestions="queryStaff2"
              @select="selectStaff2"
              :trigger-on-focus="true"
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <!-- 维保内容 -->
          <el-form-item
            v-for="(item, index) in maintenanceDictContents"
            :label="item.name"
            :key="index"
            v-if="signDialog"
          >
            <el-select
              v-model="signParam.maintenanceTypes[index].maintenanceCycleId"
              :placeholder="$t('input_65')"
              style="width: 100%"
            >
              <el-option
                v-for="(item1, index1) in maintenanceList"
                :label="item1.name"
                :value="item1.id"
                :key="index1"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('label_350')">
            <el-upload
              class="upload-demo"
              action="/"
              :show-file-list="false"
              :http-request="upload"
              :before-upload="beforeAvatarUpload"
            >
              <el-button :loading="loading">{{ uploadFileText }}</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="signDialog = false" :loading="loading"
        >{{$t('btn_1')}}</el-button
        >
        <el-button type="primary" @click="signSave()" :loading="loading"
        >{{$t('btn_8')}}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('btn_3')"
      :center="true"
      :visible.sync="detailDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="500px"
      custom-class="dialog-style dialogLoading"
    >
      <div class="dialog-content">
        <el-form ref="form" :model="detailParam" label-width="120px">
          <el-form-item :label="$t('label_257')">
            <el-autocomplete
              style="width: 100%"
              v-model="detailParam.customerName"
              :fetch-suggestions="queryCustomer"
              @select="selectCustomer"
              :trigger-on-focus="false"
              disabled
              value-key="customerName"
            >
            </el-autocomplete>
          </el-form-item>
          <el-form-item :label="$t('label_325')">
            <el-input
              v-model="detailParam.address"
              disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('label_260')">
            <el-date-picker
              v-model="detailParam.signTime"
              type="date"
              value-format="yyyy-MM-dd"
              disabled
              :placeholder="$t('input_89')"
              :clearable="false"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('label_329')">
            <el-date-picker
              v-model="detailParam.startDate"
              type="date"
              disabled
              value-format="yyyy-MM-dd"
              :placeholder="$t('input_89')"
              :clearable="false"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('label_333')">
            <el-date-picker
              v-model="detailParam.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              disabled
              :placeholder="$t('input_89')"
              :clearable="false"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('label_336')">
            <el-autocomplete
              style="width: 100%"
              v-model="detailParam.signStaffName"
              :placeholder="$t('input_36')"
              :fetch-suggestions="queryStaff1"
              @select="selectStaff1"
              disabled
              :trigger-on-focus="true"
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <el-form-item :label="$t('label_83')">
            <el-autocomplete
              style="width: 100%"
              v-model="detailParam.personChargeName"
              :placeholder="$t('input_37')"
              :fetch-suggestions="queryStaff2"
              @select="selectStaff2"
              :trigger-on-focus="true"
              disabled
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <!-- 维保内容 -->
          <el-form-item
            v-for="(item, index) in maintenanceDictContents"
            :label="item.name"
            :key="index"
            v-if="detailDialog"
          >
            <el-input
              disabled
              v-for="(item2, index2) in maintenanceTypeValue"
              :value="maintenanceTypeValue[index2].name"
              :key="index2"
              v-if="maintenanceTypeValue[index2].id == item.maintenanceTypeId"
            >
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('label_350')">
            <el-button @click="downloadFile(detailParam.contractUrl)"
            >{{$t('btn_12')}}
            </el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('btn_7')"
      :center="true"
      :visible.sync="renewalDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="500px"
      custom-class="dialog-style dialogLoading"
    >
      <div class="dialog-content">
        <el-form ref="form" :model="renewalParam" label-width="120px">
          <el-form-item :label="$t('label_257')">
            <el-input
              v-model="renewalParam.customerName"
              disabled=""
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('label_257')">
            <el-input v-model="renewalParam.address" disabled=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('label_260')">
            <el-date-picker
              v-model="renewalParam.signTime"
              type="date"
              disabled=""
              value-format="yyyy-MM-dd"
              :placeholder="$t('input_89')"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('label_329')">
            <el-date-picker
              v-model="renewalParam.startDate"
              type="date"
              disabled=""
              value-format="yyyy-MM-dd"
              :placeholder="$t('input_89')"
              :picker-options="pickerOptions2"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('label_333')">
            <el-date-picker
              v-model="renewalParam.endDate"
              type="date"
              :clearable="false"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions3"
              :placeholder="$t('input_89')"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('label_336')">
            <el-autocomplete
              style="width: 100%"
              v-model="renewalParam.signStaffName"
              :fetch-suggestions="queryStaff1"
              @select="selectStaff3"
              :trigger-on-focus="false"
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <el-form-item :label="$t('label_83')">
            <el-autocomplete
              style="width: 100%"
              v-model="renewalParam.personChargeName"
              :fetch-suggestions="queryStaff2"
              @select="selectStaff4"
              :trigger-on-focus="false"
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <!-- 维保内容 -->
          <el-form-item
            v-for="(item, index) in maintenanceDictContents"
            :label="item.name"
            :key="index"
            v-if="renewalDialog"
          >
            <el-select
              v-model="renewalParam.maintenanceTypes[index].maintenanceCycleId"
              :placeholder="$t('input_65')"
              style="width: 100%"
            >
              <el-option
                v-for="(item1, index1) in maintenanceList"
                :label="item1.name"
                :value="item1.id"
                :key="index1"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="维保模式">
            <el-select
              v-model="renewalParam.maintenanceType"
              :placeholder="$t('input_65')"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in maintenanceList"
                :label="item.name"
                :value="item.id"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item :label="$t('label_350')">
            <el-upload
              class="upload-demo"
              action="/"
              :show-file-list="false"
              :http-request="upload"
              :before-upload="beforeAvatarUpload"
            >
              <el-button :loading="loading">{{ uploadFileText }}</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="renewalDialog = false" :loading="loading"
        >{{$t('btn_1')}}</el-button
        >
        <el-button type="primary" @click="renewalSave()" :loading="loading"
        >{{$t('btn_7')}}</el-button
        >
      </span>
      <!--
        所属区域是详细地址，这个做的时候要注意
        续签时  签订日期  是 上一次的 到期日期
        续签时  到期日期  默认 一年
        续签时  签订人员 默认 签订时的人员，可以修改
        续签时  负责人员 默认 签订时的人员，可以修改
        续签时  维保模式 默认 签订时的，可以修改
       -->
    </el-dialog>
  </div>
</template>

<script>
  import "@/assets/css/common/list.css";
  import List from "@/components/list/list2";
  import Page from "@/components/common/page";
  import Contract from "@/assets/js/contract/contract.js";
  import CommonJs from "@/assets/js/common/common.js";
  import utils from '@/utils/utils'

  var id = 0;
  export default {
    name: "alarm",
    components: {
      Page,
      List,
    },
    data() {
      return {
        searchParam: {
          customerName: "",
          signTime: "",
          signTime2: "",
          personChargeName: "",
          maintenanceType: "",
          customerType: "",
          status: "",
        },
        options: [],
        maintenanceTypeValue: [],
        checkList: [],
        signDialog: false,
        detailDialog: false,
        signParam: {
          startDate: "",
          customerId: "",
          customerName: "",
          address: "",
          signTime: "",
          endDate: "",
          signStaff: "",
          personChargeName: "",
          personCharge: "",
          maintenanceTypes: "",
          signStaffName: "",
          areaCode: "",
        },
        detailParam: {
          id: "1581815358069424130",
          customerId: 1572775604803989500,
          customerName: "Network Corporation",
          customerType: null,
          signStaff: 1561170835605430300,
          signStaffName: "Network Corporation",
          personChargeName: "Network Corporation",
          settlementMode: null,
          status: 4,
          contractNumber: null,
          startDate: "2022-10-17",
          endDate: "2023-10-17",
          createTime: null,
          commitTime: null,
          signTime: "2022-10-17",
          lastApproverTime: null,
          remarks: null,
          maintenanceType: [],
          deviceId: null,
          areaCode: 310101017000,
          abbreviation: null,
          contact: null,
          contactPhone: null,
          officePhone: null,
          officeFax: null,
          officeMail: null,
          address: "Xigang District, Dalian",
          postcode: null,
          collectionAccount: null,
          openAccountBank: null,
          taxNumber: null,
          valid: null,
          province: "上海市",
          city: "上海市",
          district: "黄浦区",
          town: "小东门街道",
          mergerName: null,
          contractUrl: ""
        },
        renewalDialog: false,
        renewalParam: {
          // startDate: "",
          // customerId: "",
          // customerName: "",
          // address: "",
          // signTime: "",
          // endDate: "",
          // signStaff: "",
          // personChargeName: "",
          // personCharge: "",
          // maintenanceTypes: "",
          // signStaffName: "",
          // areaCode: "",
		  id: "1581815358069424130",
		  customerId: 1572775604803989500,
		  customerName: "Network Corporation",
		  customerType: null,
		  signStaff: 1561170835605430300,
		  signStaffName: "Network Corporation",
		  personChargeName: "Network Corporation",
		  settlementMode: null,
		  status: 4,
		  contractNumber: null,
		  startDate: "2022-10-17",
		  endDate: "2023-10-17",
		  createTime: null,
		  commitTime: null,
		  signTime: "2022-10-17",
		  lastApproverTime: null,
		  remarks: null,
		  maintenanceType: [],
		  deviceId: null,
		  areaCode: 310101017000,
		  abbreviation: null,
		  contact: null,
		  contactPhone: null,
		  officePhone: null,
		  officeFax: null,
		  officeMail: null,
		  address: "Xigang District, Dalian",
		  postcode: null,
		  collectionAccount: null,
		  openAccountBank: null,
		  taxNumber: null,
		  valid: null,
		  province: "上海市",
		  city: "上海市",
		  district: "黄浦区",
		  town: "小东门街道",
		  mergerName: null,
		  contractUrl: ""
        },
        stateList: [{
          id: 0,
          name: this.$t('label_278')
        }, {
          id: 1,
          name: this.$t('label_280')
        }, {
          id: 2,
          name: this.$t('label_283')
        }, {
          id: 3,
          name: this.$t('label_286')
        }, {
          id: 4,
          name: this.$t('btn_5')
        }],

        spotStatusNumList: [{
          icon: 'el-icon-news',
          text: this.$t('label_278'),
          check: true,
          num: '0',
          color: '#ffb400'
        }, {
          icon: 'el-icon-video-play',
          text: this.$t('label_280'),
          check: true,
          num: '0',
          color: '#8a00ff'
        }, {
          icon: 'el-icon-time',
          text: this.$t('label_283'),
          check: true,
          num: '0',
          color: '#0353c1'
        }, {
          icon: 'el-icon-close',
          text: this.$t('label_286'),
          check: true,
          num: '0',
          color: '#e60000'
        }, {
          icon: 'el-icon-refresh-left',
          text: this.$t('btn_5'),
          check: true,
          num: '0',
          color: '#3fb393'
        }],
        customerTypeList: [],
        maintenanceList: [],
        maintenanceDictContents: [],
        personChargeNameList: [],
        tableList: [
          {
            column: "customerName",
            title: this.$t('label_257'),
            headerAlign: "center",
            align: "center",
            width: "20%",
          },
          {
            column: "address",
            title: this.$t('label_325'),
            headerAlign: "center",
            align: "center",
            width: "20%",
          },
          {
            column: "signTime",
            title: this.$t('label_260'),
            headerAlign: "center",
            align: "center",
            width: "20%",
          },
          {
            column: "startDate",
            title: this.$t('label_329'),
            headerAlign: "center",
            align: "center",
            width: "20%",
          },
          {
            column: "endDate",
            title: this.$t('label_333'),
            headerAlign: "center",
            align: "center",
            width: "20%",
          },
          {
            column: "signStaffName",
            title: this.$t('label_336'),
            headerAlign: "center",
            align: "center",
            width: "20%",
          },
          {
            column: "personChargeName",
            title: this.$t('label_83'),
            headerAlign: "center",
            align: "center",
            width: "20%",
          },
          {
            column: "status",
            title: this.$t('label_275'),
            headerAlign: "center",
            align: "center",
            termList: [],
            width: "20%",
          },
        ],
        tableData: [
          {
            id: "1581815358069424130",
            customerId: 1572775604803989500,
            customerName: "Network Corporation",
            customerType: null,
            signStaff: 1561170835605430300,
            signStaffName: "Network Corporation",
            personChargeName: "Network Corporation",
            settlementMode: null,
            status: 4,
            contractNumber: null,
            startDate: "2022-10-17",
            endDate: "2023-10-17",
            createTime: null,
            commitTime: null,
            signTime: "2022-10-17",
            lastApproverTime: null,
            remarks: null,
            maintenanceType: [],
            deviceId: null,
            areaCode: 310101017000,
            abbreviation: null,
            contact: null,
            contactPhone: null,
            officePhone: null,
            officeFax: null,
            officeMail: null,
            address: "Xigang District, Dalian",
            postcode: null,
            collectionAccount: null,
            openAccountBank: null,
            taxNumber: null,
            valid: null,
            province: "上海市",
            city: "上海市",
            district: "黄浦区",
            town: "小东门街道",
            mergerName: null,
            contractUrl: ""
          }, {
            id: "1581815358069424130",
            customerId: 1572775604803989500,
            customerName: "サテライトオフィス",
            customerType: null,
            signStaff: 1561170835605430300,
            signStaffName: "鎌田 留美子",
            personChargeName: "鎌田 留美子",
            settlementMode: null,
            status: 4,
            contractNumber: null,
            startDate: "2022-10-17",
            endDate: "2023-10-17",
            createTime: null,
            commitTime: null,
            signTime: "2022-10-17",
            lastApproverTime: null,
            remarks: null,
            maintenanceType: [],
            deviceId: null,
            areaCode: 310101017000,
            abbreviation: null,
            contact: null,
            contactPhone: null,
            officePhone: null,
            officeFax: null,
            officeMail: null,
            address: "神奈川県横浜市港北区新横浜3-20-8",
            postcode: null,
            collectionAccount: null,
            openAccountBank: null,
            taxNumber: null,
            valid: null,
            province: "上海市",
            city: "上海市",
            district: "黄浦区",
            town: "小东门街道",
            mergerName: null,
            contractUrl: ""
          },
        ],
        sheet: [
          {
            title: "合同表",
            tHeader: [
              "客户名称",
              "所在区域地址",
              "签订日期",
              "开始日期",
              "到期日期",
              "签订人员",
              "负责人员",
              // "维保模式",
              "合同状态",
            ],
            keys: [
              "customerName",
              "address",
              "signTime",
              "startDate",
              "endDate",
              "signStaffName",
              "personChargeName",
              // "maintenanceTypeName",
              "statusName",
            ],
            table: [],
            sheetName: "合同",
            cellStyle: [
              {
                cell: "A1",
                font: {
                  name: "黑体",
                  sz: "18px",
                },
              },
            ],
          },
        ],
        tableInfo: {},
        pageCount: 2,
        pageSize: 10,
        pageNo: 1,
        menuList: [],
        filePath: "",
        uploadFileText: this.$t('btn_11'),
        loading: false,
      };
    },
    computed: {
      pickerOptions0() {
        return {
          disabledDate: (time) => {
            if (this.signParam.endDate) {
              return time.getTime() > new Date(this.signParam.endDate).getTime();
            } else {
              return time.getTime() < Date.now() - 8.64e7;
            }
          },
        };
      },
      pickerOptions1() {
        return {
          disabledDate: (time) => {
            if (this.signParam.startDate) {
              return (
                time.getTime() <
                new Date(this.signParam.startDate).getTime() +
                30 * 24 * 60 * 60 * 1000
              );
            } else {
              return time.getTime() < Date.now() - 8.64e7;
            }
          },
        };
      },
      pickerOptions2() {
        return {
          disabledDate: (time) => {
            if (this.renewalParam.endDate) {
              return (
                time.getTime() > new Date(this.renewalParam.endDate).getTime()
              );
            } else {
              return time.getTime() < Date.now() - 8.64e7;
            }
          },
        };
      },
      pickerOptions3() {
        return {
          disabledDate: (time) => {
            if (this.renewalParam.startDate) {
              return (
                time.getTime() <
                new Date(this.renewalParam.startDate).getTime() +
                30 * 24 * 60 * 60 * 1000
              );
            } else {
              return time.getTime() < Date.now() - 8.64e7;
            }
          },
        };
      },
    },
    methods: {
      getIndex(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1;
      },
      upload(res, file) {
        let formdata = new FormData();
        formdata.append("file", res.file);
        this.loading = true;
        Contract.uploadFile(formdata)
          .then((response) => {
            let data = response.data;
            if (data.code == 1) {
              this.loading = false;
              this.filePath = data.data;
              let fileName = data.data.split("\\")[2].split(".")[0];
              this.uploadFileText = this.$t('msg_15') + "  " + fileName;
            } else {
              this.loading = false;
              this.uploadFileText = this.$t('btn_11');
              utils.messageAlert(this.$t('label_404'), this.$t('label_358'), this.$t('label_100'));
            }
          })
          .catch((response) => {
            this.loading = false;
            utils.messageAlert(this.$t('label_404'), this.$t('label_358'), this.$t('label_100'));
          });
      },
      downloadFile(url) {
        if (url == "") {
          utils.messageAlert(this.$t('label_362'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        window.location.href =
          "https://www.sfrsafety.com:8443/contract/download/file?fileName=" +
          encodeURI(url);
        //"http://10.200.0.16:8091/contract/download/file?fileName=" +
      },
      beforeAvatarUpload() {
      },
      queryArea(item) {
        let param = {
          pageNo: 1,
          pageSize: this.pageSize,
        };
        if (item == "all") {
          this.$delete(this.searchParam, "city");
          this.$delete(this.searchParam, "district");
          param = Object.assign(param, item);
          this.search(param);
        } else {
          this.$delete(this.searchParam, "city");
          this.$delete(this.searchParam, "district");
          param = Object.assign(param, item);
          this.searchParam = Object.assign(this.searchParam, item);
          this.search(param);
        }
      },
      getContractStatusList() {
        CommonJs.getDict("合同状态")
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              let list = [];
              data.data.forEach(function (item, index) {
                var param = {};
                param.id = item.rank;
                param.name = item.value;
                param.color = item.value1;
                list.push(param);
              });
              this.stateList = list;
              this.tableList[7].termList = list;
            }
          })
          .catch((response) => {
          });
      },
      Invalid() {
        // if (Object.keys(this.tableInfo).length > 0) {
        this.$confirm(this.$t('label_313'), this.$t('label_358'), {
          confirmButtonText: this.$t('btn_20'),
          cancelButtonText: this.$t('btn_1'),
          type: "warning",
        })
          .then(() => {
            let list = {
              id: this.tableInfo.id,
              status: 4,
            };
            Contract.edit(list).then((response) => {
              const data = response.data;
              if (data.code == 1) {
                utils.tipsAlert(this.$t('btn_5') + data.message);
                this.search({
                  pageNo: this.pageNo,
                  pageSize: this.pageSize,
                });
              }
            });
          })
          .catch(() => {
          });
        // } else {
        //   this.utils.tipsAlert(this.$t('input_38'));
        // }
      },
      detail() {
        if (Object.keys(this.tableInfo).length > 0) {
          this.detailParam = this.tableInfo;
          this.maintenanceTypeValue = [];
          for (var i = 0; i < this.maintenanceList.length; i++) {
            for (var q = 0; q < this.detailParam.maintenanceType.length; q++) {
              if (
                this.maintenanceList[i].id ==
                this.detailParam.maintenanceType[q].maintenanceCycleId
              ) {
                this.maintenanceTypeValue.push({
                  id: this.detailParam.maintenanceType[q].maintenanceTypeId,
                  name: this.maintenanceList[i].name,
                });
              }
            }
          }
          this.detailDialog = true;
        } else {
          utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
        }
      },
      getMaintenanceList() {
        CommonJs.getDict("维保类型")
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              let list = [];
              data.data.forEach(function (item, index) {
                var param = {};
                param.id = item.id;
                param.name = item.value;
                list.push(param);
              });
              this.maintenanceList = list;
            }
          })
          .catch((response) => {
          });
      },
      getCustomerTypeList() {
        CommonJs.getDict("客户类型")
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              let list = [];
              data.data.forEach(function (item, index) {
                var param = {};
                param.id = item.rank;
                param.name = item.value;
                list.push(param);
              });
              this.customerTypeList = list;
            }
          })
          .catch((response) => {
          });
      },
      getPersonChargeNameList() {
        CommonJs.getAllUserInfo()
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              this.personChargeNameList = data.data;
            }
          })
          .catch((response) => {
          });
      },
      queryCustomer(queryString, cb) {
        Contract.getByName(queryString)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              cb(data.data);
            }
          })
          .catch((response) => {
          });
      },
      selectCustomer(item) {
        this.signParam.customerId = item.id;
        this.signParam.customerName = item.customerName;
        this.signParam.address = item.address;
        this.signParam.areaCode = item.areaCode;
      },
      queryStaff1(queryString, cb) {
        if (queryString == undefined) {
          queryString = "";
        }
        CommonJs.getAllUserInfo(queryString)
          .then((response) => {
            let data = response.data;
            if (data.code == 1) {
              cb(data.data);
            }
          })
          .catch((response) => {
          });
      },
      queryStaff2(queryString, cb) {
        CommonJs.getAllUserInfo(queryString)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              cb(data.data);
            }
          })
          .catch((response) => {
          });
      },
      selectStaff1(item) {
        this.signParam.signStaff = item.userId;
        this.signParam.signStaffName = item.fullName;
      },
      selectStaff2(item) {
        this.signParam.personCharge = item.userId;
        this.signParam.personChargeName = item.fullName;
      },
      selectStaff3(item) {
        this.renewalParam.signStaff = item.userId;
        this.renewalParam.signStaffName = item.fullName;
      },
      selectStaff4(item) {
        this.renewalParam.personCharge = item.userId;
        this.renewalParam.personChargeName = item.fullName;
      },
      searchStatus(status) {
        if (this.searchParam.status !== status) {
          this.searchParam.status = status;
        } else {
          this.searchParam.status = "";
        }
      },
      search(param) {
        if (this.searchParam.customerName != "") {
          param.customerName = this.searchParam.customerName;
        }
        if (
          this.searchParam.signTime != "" &&
          this.searchParam.signTime != null &&
          this.searchParam.signTime2 != "" &&
          this.searchParam.signTime2 != null
        ) {
          param.signTime = this.searchParam.signTime;
          param.signTime2 = this.searchParam.signTime2;
        } else {
          if (
            (this.searchParam.signTime != "" &&
              this.searchParam.signTime != null) ||
            (this.searchParam.signTime2 != "" &&
              this.searchParam.signTime2 != null)
          ) {
            utils.messageAlert(this.$t('input_39'), this.$t('label_358'), this.$t('label_100'));
          }
        }
        if (this.searchParam.personChargeName != "") {
          param.personChargeName = this.searchParam.personChargeName;
        }
        if (this.searchParam.customerType !== "") {
          param.customerType = this.searchParam.customerType;
        }
        if (this.searchParam.maintenanceType !== "") {
          param.maintenanceType = this.searchParam.maintenanceType;
        }
        if (
          this.searchParam.district != "" &&
          this.searchParam.district != undefined
        ) {
          param.district = this.searchParam.district;
        }
        if (this.searchParam.status !== "") {
          param.status = this.searchParam.status;
        }
        this.post(param);
        this.getExcelList(param);
      },
      getExcelList(param) {
        Contract.getContractExcel(param)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              var list = [];
              var $this = this;
              data.data.forEach(function (item, index) {
                var newItem = {};
                newItem.customerName =
                  item.customerName == null ? " " : item.customerName;
                newItem.address = item.address == null ? " " : item.address;
                newItem.signTime = item.signTime == null ? " " : item.signTime;
                newItem.startDate = item.startDate == null ? " " : item.startDate;
                newItem.endDate = item.endDate == null ? " " : item.endDate;
                newItem.signStaffName =
                  item.signStaffName == null ? " " : item.signStaffName;
                newItem.personChargeName =
                  item.personChargeName == null ? " " : item.personChargeName;
                $this.stateList.forEach(function (item1, index1) {
                  if (item.status === item1.id) {
                    newItem.statusName = item1.name;
                  }
                });
                $this.maintenanceList.forEach(function (item1, index1) {
                  if (item.maintenanceType === item1.id) {
                    newItem.maintenanceTypeName = item1.name;
                  }
                });
                list.push(newItem);
              });
              this.sheet[0].table = list;
            }
          })
          .catch((response) => {
          });
      },
      post(param) {
        Contract.getContract(param)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              this.pageCount = data.data.total;
              this.pageNo = data.data.pages;
              this.$refs["pageModel"].setCurrent(this.pageNo);
              let list = [];
              let nowTime = new Date();
              this.tableData = data.data.records;
            }
          })
          .catch((response) => {
          });
      },
      signSave() {
        var param = this.signParam;
        if (this.signParam.customerId == "") {
          utils.messageAlert(this.$t('input_31'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (this.signParam.signTime == "") {
          utils.messageAlert(this.$t('input_40'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (this.signParam.startDate == "") {
          utils.messageAlert(this.$t('input_41'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (this.signParam.endDate == "") {
          utils.messageAlert(this.$t('input_42'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (this.signParam.signStaff == "") {
          utils.messageAlert(this.$t('input_36'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (this.signParam.personChargeName == "") {
          utils.messageAlert(this.$t('input_37'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        for (
          let index = 0;
          index < this.signParam.maintenanceTypes.length;
          index++
        ) {
          if (
            this.signParam.maintenanceTypes[index].maintenanceCycleId == null ||
            this.signParam.maintenanceTypes[index].maintenanceCycleId == ""
          ) {
            utils.messageAlert(this.$t('input_33'), this.$t('label_358'), this.$t('label_100'));
            return;
          }
        }

        param.contractUrl = this.filePath;
        Contract.add(param)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              if (data.data == true) {
                // utils.tipsAlert("合同创建成功");
                utils.messageAlert(this.$t('msg_23'), this.$t('label_358'), this.$t('label_100'));
                this.search({
                  pageNo: this.pageNo,
                  pageSize: this.pageSize,
                });
                this.signDialog = false;
              } else {
                utils.messageAlert(this.$t('label_379'), this.$t('label_358'), this.$t('label_100'));
              }
            }
          })
          .catch((response) => {
          });
        this.signParam.clear();
      },
      renewalSave() {
        var param = this.renewalParam;
        param.contractUrl = this.filePath;
        if (this.renewalParam.customerId == "") {
          utils.messageAlert(this.$t('input_31'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (this.renewalParam.signTime == "") {
          utils.messageAlert(this.$t('input_40'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (this.renewalParam.startDate == "") {
          utils.messageAlert(this.$t('input_41'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (this.renewalParam.endDate == "") {
          utils.messageAlert(this.$t('input_42'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (this.renewalParam.signStaff == "") {
          utils.messageAlert(this.$t('input_36'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (this.renewalParam.personChargeName == "") {
          utils.messageAlert(this.$t('input_37'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (this.renewalParam.maintenanceTypes == "") {
          utils.messageAlert(this.$t('input_33'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        Contract.add(param)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              utils.saveAlert();
              this.search({
                pageNo: this.pageNo,
                pageSize: this.pageSize,
              });
              this.renewalDialog = false;
            }
          })
          .catch((response) => {
          });
      },
      getInfo(info) {
        this.tableInfo = info;
      },
      getArea(param) {
      },
      sign() {
        this.signDialog = true;
        var d = new Date();
        var seperator1 = "-";
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var strDate = d.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        this.getDictList();
        this.signParam = {
          customerId: "",
          signTime: year + seperator1 + month + seperator1 + strDate,
          startDate: year + seperator1 + month + seperator1 + strDate,
          endDate: this.date(year + seperator1 + month + seperator1 + strDate),
          signStaff: this.$store.getters.getUserInfo.userId,
          personChargeName: this.$store.getters.getUserInfo.fullName,
          personCharge: this.$store.getters.getUserInfo.userId,
          maintenanceTypes: this.maintenanceDictContents,
          signStaffName: this.$store.getters.getUserInfo.fullName,
          areaCode: "",
        };
        this.filePath = "";
        this.uploadFileText = this.$t('btn_11');
      },
      date(date) {
        var d = new Date(date);
        d.setFullYear(d.getFullYear() + 1);
        var seperator1 = "-";
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var strDate = d.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return year + seperator1 + month + seperator1 + strDate;
      },
      renewal() {
        // if (Object.keys(this.tableInfo).length > 0) {
        Contract.getById(this.tableInfo.id).then((response) => {
          const data = response.data;
          if (data.code == 1) {
            this.getDictList();
            this.renewalDialog = true;
            this.renewalParam = {
              contractId: this.tableInfo.id,
              customerId: data.data.id,
              customerName: data.data.customerName,
              areaCode: data.data.areaCode,
              address: data.data.address,
              signTime: data.data.signTime,
              startDate: data.data.endDate,
              endDate: this.date(data.data.endDate),
              signStaff: data.data.signStaff,
              personChargeName: data.data.personChargeName,
              personCharge: data.data.personCharge,
              maintenanceTypes: this.maintenanceDictContents,
              signStaffName: data.data.signStaffName,
            };
            this.filePath = data.data.filePath;
          }
        });
        // } else {
        //   this.utils.tipsAlert(this.$t('input_38'));
        // }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getDictList() {
        CommonJs.getDict("维护类型")
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              let list = [];
              data.data.forEach(function (item, index) {
                var param = {};
                param.maintenanceTypeId = item.id;
                param.name = item.value;
                list.push(param);
              });
              this.maintenanceDictContents = list;
            }
          })
          .catch((response) => {
          });
      },
      getNowTime(time) {
        var now = time;
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth(); //得到月份
        var date = now.getDate(); //得到日期
        month = month + 1;
        month = month.toString().padStart(2, "0");
        date = date.toString().padStart(2, "0");
        var defaultDate = `${year}-${month}-${date}`;
        return defaultDate;
      },
      getInspectionContentList() {
        Contract.getInspectionContent().then((response) => {
          const data = response.data;
          if (data.code == 1) {
            console.log("数据：" + data);
          }
        })
          .catch((response) => {
          });
      },
    },


    created() {
      /*    this.getContractStatusList();
          this.getMaintenanceList();
          this.getCustomerTypeList();
          this.getPersonChargeNameList();
          this.search({
            pageNo: 1,
            pageSize: 10,
          });
          this.menuList = this.$store.getters.getMenuPermission;
          this.getDictList();
          this.searchParam.signTime2 = this.getNowTime(new Date());
          this.searchParam.signTime = this.getNowTime(
            new Date(new Date().setFullYear(new Date().getFullYear() - 1))
          );
              this.getInspectionContentList();*/

    },
  };
</script>
<style>
  .searchBox-condition .date-class .el-input__inner {
    border: 0;
    background-color: #f5f5f5;
    height: 30px;
    border-radius: 15px;
  }

  .searchBox-condition .date-class .el-range-input {
    background-color: #f5f5f5;
  }

  .searchBox-condition .select-class .el-input__icon {
    line-height: 40px;
    margin-top: 10px;
  }
  .list-table-block {
     position: absolute;
     height: 100%;
     width: 100%;
     background: #fff;
     padding: 5px 10px 0;
   }
  .black-table .el-table__header-wrapper .el-table__header .has-gutter tr th {
    background: #45494f;
    border: 0;
    color: #fff;
  }
  .searchBox-condition .el-input__icon{
    line-height: 40px;
  }
  .searchBox-condition .el-input__prefix, .searchBox-condition .el-input__suffix{
    top:-5px
  }
</style>



// WEBPACK FOOTER //
// src/pages/contract/list.vue